import Moment from 'moment';

export default class Place {
    constructor(place={}) {
        Object.assign(this, place);
        this.date = Moment(this.date);
    }
}